//import './App.css';
import { Route, Routes} from 'react-router-dom';
import { HashRouter as Router } from 'react-router-dom';


import Navbar from './NavBar';
import DOTS from './assets/circles.png';
import Blog from "./blog";
//import Committees from "./committees";
import Resources, { CarouselItem } from "./components/resources/resources";
import Home from './home';
import Leadership from './leadership';
import Event from './event';
import Involved from './involved';
import Snapshots from './snapshots';

import APPSNOMS23 from './posts/22-23/APPSNOMS23';
import Bowling23 from './posts/22-23/Bowling23';
import CTI23 from './posts/22-23/CTI23';
import ComAppAnnounce from './posts/22-23/ComAppAnnounce';
import Cookies22 from './posts/22-23/Cookies22';
import ElectionsResults from './posts/22-23/ElectionsResults';
import Equity23 from './posts/22-23/Equity23';
import FLWR23 from './posts/22-23/FLWR23';
import Fall22MM1Recap from './posts/22-23/Fall22MM1Recap';
import GHCTapia22Recap from './posts/22-23/GHCTapia22Recap';
import GoogleSplunk22Recap from './posts/22-23/GoogleSplunk22Recap';
import NameChange from './posts/22-23/NameChange';
import PMTalk from './posts/22-23/PMTalk';
import RebrandSurvey22 from './posts/22-23/RebrandSurvey22';
import Swag23 from './posts/22-23/Swag23';
import WAD22 from './posts/22-23/WAD22';
import WIR23 from './posts/22-23/WIR23';
import MM1 from './components/posts/23-24/MM1';
import Uber from './components/posts/23-24/Uber';
import Pinterest from './components/posts/23-24/Pinterest';
import Googlerecap from './components/posts/23-24/Googlerecap';
import Gracehopper from './components/posts/23-24/gracehopperrecap';
import Friendsgiving from './components/posts/23-24/friendsgiving';
import December from './components/posts/23-24/december';
import Slumber from './components/posts/23-24/Slumber';
import WAD from './components/posts/23-24/wad';
import Candle from './components/posts/23-24/candle';
import Galentine from './components/posts/23-24/galentines';
import Tech from './components/posts/23-24/techentre';
import Teaparty from './components/posts/23-24/teaparty';
import Women from './components/posts/23-24/women';
import Percentproject from './components/posts/23-24/percentproject';
import Icecream from './components/posts/23-24/icecream';
import Combio from './committeebios';
import Cseed from './components/posts/23-24/cseed';
import Multicultural from './components/posts/23-24/multiculturalnight';
import PMTalks from './components/posts/23-24/pmtalks';
import Thetradedesk from './components/posts/23-24/ttd';
import Potluck from './components/posts/23-24/potluck';
import Serviceday from './components/posts/23-24/serviceday';
import Outreach from './components/posts/23-24/outreach';
import Officer25 from './components/posts/23-24/officer25';
import BobaKahoot from './components/posts/24-25/BobaKahoot';
import Stripe24 from './components/posts/24-25/Stripe24';
import Speed from './components/posts/24-25/Speed';
import Friendsgiving24 from './components/posts/24-25/Friendsgiving';
import GHCTapia from './components/posts/24-25/GHCTapia';
import Ornament from './components/posts/24-25/Ornament';
import Meta from './components/posts/24-25/Meta';
import HiyaX from './components/posts/24-25/HiyaX';
import Buildher from './components/posts/24-25/Buildher';
import Evening from './components/posts/24-25/Evening';
import Crochet from './components/posts/24-25/Crochet';
import Womens from './components/posts/24-25/Womens';
import Cherry from './components/posts/24-25/Cherry';
import Trailblazer from './components/posts/24-25/Trailblazer';
import Phone from './components/posts/24-25/Phone';
import Trade from './components/posts/24-25/Trade';
import Clean from './components/posts/24-25/Clean';
import CSA from './components/posts/24-25/CSA';
import Game from './components/posts/24-25/Game';
import Service from './components/posts/24-25/Service';
import Hiya from './components/posts/24-25/Hiya';
import Origami from './components/posts/24-25/Origami';
import Alumni from './components/posts/24-25/Alumni';
import WomenAI from './components/posts/24-25/WomenAI';
import Faculty from './components/posts/24-25/Faculty';
import TradeDeskTechInterview from './components/posts/25-26/TradeDeskTechInterview';
import AuMM1 from './components/posts/25-26/AuMM1';
import AuMM2 from './components/posts/25-26/AuMM2';
import OpenAIFireside from './components/posts/25-26/OpenAIFireside';
import Friendsgiving25 from './components/posts/25-26/Friendsgiving';
import SurvivorStudySesh from './components/posts/25-26/SurvivorStudySesh';
import Y2KNight from './components/posts/25-26/Y2KNight';
import ResearchFireside from './components/posts/25-26/ResearchFireside';
import HiyaFireside from './components/posts/25-26/HiyaFireside';
import InternationalWomensDay from './components/posts/25-26/InternationalWomensDay';
import WinterStudySesh from './components/posts/25-26/WinterStudySesh';
import Microsoft from './components/posts/25-26/Microsoft';
import CherryBlossoms from './components/posts/25-26/CherryBlossoms';
import CleanPowerResearch from './components/posts/25-26/CleanPowerResearch';
import SpringKickoffPicnic from './components/posts/25-26/SpringKickoffPicnic';
import TradeDeskLinkedIn from './components/posts/25-26/TradeDeskLinkedIn'
import Watercolor from './components/posts/25-26/Watercolor';
import ChloeMemberSpotlight from './components/posts/25-26/ChloeMemberSpotlight'; 

    const ResourcesComponent = () => {
      const carouselItems = [
        <CarouselItem
          key={1}
          width="96%"
          url="https://bootcamp.pe.gatech.edu/blog/how-to-empower-girls-in-stem/"
        >
          <p>
          Breaking the Glass Ceiling Early On:
          </p>
          <p>How to Empower Girls in STEM</p>

        </CarouselItem>,
        <CarouselItem key={2} width="96%" url="https://www.cs.washington.edu/diversity">
          UW CSE Diversity Page
        </CarouselItem>,
        <CarouselItem key={3} width="96%" url="https://www.certstaff.com/classes/history-women-computers.html">
          History of Women and Computing
        </CarouselItem>
      ];


      return (
        <Resources carouselItems={carouselItems} gridWidgets={null} />
      );
    };


function App() {
  return (
    <Router>
      <img className='graphic' src={DOTS} alt='semi-transparent dots background'></img>
    <Navbar />
    <Routes>
        <Route exact path='/' element={<Home/>} />
        {/* <Route path='/committees' element={<Combio/>} /> */}
        <Route path='/blog' element={<Blog/>} />
        <Route path='/leadership' element={<Leadership/>} />
        <Route path='/event' element={<Event/>} />
        <Route path='/involved' element={<Involved/>} />
        <Route path='/resources' element={<ResourcesComponent> </ResourcesComponent>} />
        <Route path='/snapshots' element={<Snapshots/>} />

        <Route path='/posts/22-23/ElectionsResults' element={<ElectionsResults/>} />
        <Route path='/posts/22-23/PMTalk' element={<PMTalk/>} />
        <Route path='/posts/22-23/APPSNOMS23' element={<APPSNOMS23/>} />
        <Route path='/posts/22-23/FLWR23' element={<FLWR23/>} />
        <Route path='/posts/22-23/CTI23' element={<CTI23/>} />
        <Route path='/posts/22-23/Swag23' element={<Swag23/>} />
        <Route path='/posts/22-23/WIR23' element={<WIR23/>} />
        <Route path='/posts/22-23/WAD22' element={<WAD22/>} />
        <Route path='/posts/22-23/Equity23' element={<Equity23/>} />
        <Route path='/posts/22-23/Bowling23' element={<Bowling23/>} />
        <Route path='/posts/22-23/Cookies22' element={<Cookies22/>} />
        <Route path='/posts/22-23/GoogleSplunk22Recap' element={<GoogleSplunk22Recap/>} />
        <Route path='/posts/22-23/GHCTapia22Recap' element={<GHCTapia22Recap/>} />
        <Route path='/posts/22-23/Fall22MM1Recap' element={<Fall22MM1Recap/>} />
        <Route path='/posts/22-23/ComAppAnnounce' element={<ComAppAnnounce/>} />
        <Route path='/posts/22-23/NameChange' element={<NameChange/>} />
        <Route path='/posts/22-23/RebrandSurvey22' element={<RebrandSurvey22/>} />
        <Route path='/posts/23-24/MM1' element={<MM1/>} />
        <Route path='/posts/23-24/Uber' element={<Uber/>} />
        <Route path='/posts/23-24/Pinterest' element={<Pinterest/>} />
        <Route path='/posts/23-24/Googlerecap' element={<Googlerecap/>} />
        <Route path='/posts/23-24/gracehopperrecap' element={<Gracehopper/>} />
        <Route path='/posts/23-24/friendsgiving' element={<Friendsgiving/>} />
        <Route path='/posts/23-24/december' element={<December/>} />
        <Route path='/posts/23-24/Slumber' element={<Slumber/>} />
        <Route path='/posts/23-24/wad' element={<WAD/>} />
        <Route path='/posts/23-24/candle' element={<Candle/>} />
        <Route path='/posts/23-24/galentines' element={<Galentine/>} />
        <Route path='/posts/23-24/techentre' element={<Tech/>} />
        <Route path='/posts/23-24/teaparty' element={<Teaparty/>} />
        <Route path='/posts/23-24/women' element={<Women/>} />
        <Route path='/posts/23-24/percentproject' element={<Percentproject/>} />
        <Route path='/posts/23-24/icecream' element={<Icecream/>} />
        <Route path='/committeebios' element={<Combio/>} />
        <Route path='/posts/23-24/cseed' element={<Cseed/>} />
        <Route path='/posts/23-24/multiculturalnight' element={<Multicultural/>} />
        <Route path='/posts/23-24/pmtalks' element={<PMTalks/>} />
        <Route path='/posts/23-24/ttd' element={<Thetradedesk/>} />
        <Route path='/posts/23-24/potluck' element={<Potluck/>} />
        <Route path='/posts/23-24/serviceday' element={<Serviceday/>} />
        <Route path='/posts/23-24/outreach' element={<Outreach/>} />
        <Route path='/posts/23-24/officer25' element={<Officer25/>} />
        <Route path='/posts/24-25/BobaKahoot' element={<BobaKahoot />} />
        <Route path='/posts/24-25/Stripe24' element={<Stripe24 />} />
        <Route path='/posts/24-25/Speed' element={<Speed />} />
        <Route path='/posts/24-25/Friendsgiving' element={<Friendsgiving24 />} />
        <Route path='/posts/24-25/GHCTapia' element={<GHCTapia />} />
        <Route path='/posts/24-25/Ornament' element={<Ornament />} />
        <Route path='/posts/24-25/Meta' element={<Meta />} />
        <Route path='/posts/24-25/HiyaX' element={<HiyaX />} />
        <Route path='/posts/24-25/Buildher' element={<Buildher />} />
        <Route path='/posts/24-25/Evening' element={<Evening />} />
        <Route path='/posts/24-25/Crochet' element={<Crochet/>} />
        <Route path='/posts/24-25/Womens' element={<Womens />} />
        <Route path='/posts/24-25/Cherry' element={<Cherry />} />
        <Route path='/posts/24-25/Trailblazer' element={<Trailblazer />} />
        <Route path='/posts/24-25/Phone' element={<Phone />} />
        <Route path='/posts/24-25/Trade' element={<Trade />} />
        <Route path='/posts/24-25/Clean' element={<Clean />} />
        <Route path='/posts/24-25/CSA' element={<CSA />} />
        <Route path='/posts/24-25/Game' element={<Game />} />
        <Route path='/posts/24-25/Service' element={<Service />} />
        <Route path='/posts/24-25/Hiya' element={<Hiya />} />
        <Route path='/posts/24-25/Origami' element={<Origami />} />
        <Route path='/posts/24-25/Alumni' element={<Alumni />} />
        <Route path='/posts/24-25/WomenAI' element={<WomenAI />} />
        <Route path='/posts/24-25/Faculty' element={<Faculty />} />
        <Route path='/posts/25-26/TradeDeskTechInterview' element={<TradeDeskTechInterview />} />
        <Route path='/posts/25-26/AuMM1' element={<AuMM1 />} />
        <Route path='/posts/25-26/AuMM2' element={<AuMM2 />} />
        <Route path='/posts/25-26/OpenAIFireside' element={<OpenAIFireside />} />
        <Route path='/posts/25-26/Friendsgiving' element={<Friendsgiving25 />} />
        <Route path='/posts/25-26/SurvivorStudySesh' element={<SurvivorStudySesh />} />
        <Route path='/posts/25-26/Y2KNight' element={<Y2KNight />} />
        <Route path='/posts/25-26/ResearchFireside' element={<ResearchFireside />} />
        <Route path='/posts/25-26/HiyaFireside' element={<HiyaFireside />} />
        <Route path='/posts/25-26/InternationalWomensDay' element={<InternationalWomensDay />} />
        <Route path='/posts/25-26/WinterStudySesh' element={<WinterStudySesh />} />
        <Route path='/posts/25-26/Microsoft' element={<Microsoft />} />
        <Route path='/posts/25-26/CherryBlossoms' element={<CherryBlossoms />} />
        <Route path='/posts/25-26/CleanPowerResearch' element={<CleanPowerResearch />} />
        <Route path='/posts/25-26/SpringKickoffPicnic' element={<SpringKickoffPicnic />} />
        <Route path='/posts/25-26/TradeDeskLinkedIn' element={<TradeDeskLinkedIn />} />
        <Route path='/posts/25-26/Watercolor' element={<Watercolor />} />
        <Route path='/posts/25-26/ChloeMemberSpotlight' element={<ChloeMemberSpotlight />} />
    </Routes>
    </Router>
  );
}

export default App;
